import { render, staticRenderFns } from "./DownloadCertificatesDialog.vue?vue&type=template&id=53f301e8&scoped=true"
import script from "./DownloadCertificatesDialog.vue?vue&type=script&lang=js"
export * from "./DownloadCertificatesDialog.vue?vue&type=script&lang=js"
import style0 from "./DownloadCertificatesDialog.vue?vue&type=style&index=0&id=53f301e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53f301e8",
  null
  
)

export default component.exports